import { render } from "./OnboardingDashboard.vue?vue&type=template&id=ff604938&scoped=true"
import script from "./OnboardingDashboard.vue?vue&type=script&lang=js"
export * from "./OnboardingDashboard.vue?vue&type=script&lang=js"

import "./OnboardingDashboard.vue?vue&type=style&index=0&id=ff604938&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff604938"]])

export default __exports__